function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Box",
  width: 25,
  height: 25,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_2018",
  "data-name": "Trac\\xE9 2018",
  stroke: "#25265840",
  strokeWidth: 2,
  d: "M251.87,67.07a2.088,2.088,0,0,1-2.835,0l-.1-.106c-5.46-5.072-9.135-8.348-9.03-12.364a5.977,5.977,0,0,1,2.415-4.544,6.082,6.082,0,0,1,8.085,1.162,6.064,6.064,0,0,1,8.085-1.162A5.673,5.673,0,0,1,260.9,54.6c.105,4.121-3.465,7.4-9.03,12.47Z",
  transform: "translate(-238 -46)",
  fill: "#fff"
});

function SvgHeartEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coeur_plein",
    "data-name": "coeur plein",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEmpty);
export default __webpack_public_path__ + "static/media/heartEmpty.03cc0dcab3f34da7981be6b01375b5eb.svg";
export { ForwardRef as ReactComponent };